export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path === from.path) {
    console.log('NUXT3 - BP Repo - Navigate to', to.path)
  } else {
    console.log('NUXT3 - BP Repo - Navigate to', to.path, 'from', from.path)
  }
})
